import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { message } from '@generated/ai-chat-bot/controllers/ai-chatbot/ai-chatbot';
import { type ChatbotRequest, type ChatbotResponse } from '@generated/ai-chat-bot';
/**
 * Send a message to the chatbot using the `/api/v1/ai-chatbot/message` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/chatbot/messageChatbot Search API Documentation}
 */
export const messageChatbot = async (chatbotRequest: ChatbotRequest, apiConfig: ApiConfig): Promise<ApiResult<ChatbotResponse>> => {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'messageChatbot');
    const data = await message(chatbotRequest, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
};
